<template>
    <div id="question-history-view" class="page-layout__inner">
        <div class="page-layout__row">
            <div class="row">
                <div class="col-md-10">
                    <div v-if="question.id" class="page-layout__group-2">
                        <section class="section">
                            <div class="section__header">
                                <h3 class="card-post__title  section__title">{{ getTranslation('generalInfo') }}</h3>
                            </div>
                            <div class="section__body col-sm-10">
                                <table class="table-doc">
                                    <tbody>
                                        <tr>
                                            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('questionID') }}:</th>
                                            <td class="table-doc__cell"><strong>{{ question.questionId }}</strong></td>
                                        </tr>
                                        <tr>
                                            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('user') }}:</th>
                                            <td class="table-doc__cell"><strong v-if="question.user">{{ question.user.fullName }}</strong></td>
                                        </tr>
                                        <tr>
                                            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('editionDate') }}:</th>
                                            <td class="table-doc__cell"><strong>{{ question.creationDate }}</strong></td>
                                        </tr>
                                        <tr>
                                            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('namingNPA') }}:</th>
                                            <td class="table-doc__cell">
                                                <span :class="{'dirtyData--class':question.dirtyData.includes('test')}">{{ question.test.title }}</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('type') }}:</th>
                                            <td class="table-doc__cell">
                                                <span :class="{'dirtyData--class':question.dirtyData.includes('type')}">
                                                    {{question.type.title}}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('status') }}:</th>
                                            <td class="table-doc__cell">
                                                <span :class="{'dirtyData--class':question.dirtyData.includes('status')}">
                                                    {{ question.statusTitle }}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('questionSection') }}:</th>
                                            <td class="table-doc__cell">
                                                <span :class="{'dirtyData--class':question.dirtyData.includes('section')}">
                                                    {{question.section}}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="table-doc__cell  table-doc__cell--head">
                                                {{ getTranslation('questionSection') }}
                                                ({{ getTranslation('ky_KG') }}):
                                            </th>
                                            <td class="table-doc__cell">
                                                <span :class="{'dirtyData--class':question.dirtyData.includes('sectionKy')}">
                                                    {{ question.sectionKy }}
                                                </span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('ru_RU') }}:</th>
                                            <td class="table-doc__cell">
                                                <MathJaxComponent :class="{'dirtyData--class':question.dirtyData.includes('questionRu')}" v-if="question.type.slug === 'fill_in'" :formula="question.questionRu" />
                                                <span :class="{'dirtyData--class':question.dirtyData.includes('questionRu')}" v-if="question.type.slug !== 'fill_in'" v-html="question.questionRu"></span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('ky_KG') }}:</th>
                                            <td class="table-doc__cell">
                                                <MathJaxComponent :class="{'dirtyData--class':question.dirtyData.includes('questionKy')}" v-if="question.type.slug === 'fill_in'" :formula="question.questionKy" />
                                                <span :class="{'dirtyData--class':question.dirtyData.includes('questionKy')}" v-if="question.type.slug !== 'fill_in'" v-html="question.questionKy"></span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-10">
                    <section class="tabs-3">
                        <ul class="nav  tabs-3__nav  tabs-3__hor-nav">
                            <li class="tabs-3__nav-item">
                                <a :class="'tabs-3__nav-link active'" href="javascript:void(0)">{{ getTranslation('answers') }}</a>
                            </li>
                        </ul>
                        <div class="tabs-3__content  tabs-3__content--p-0">
                            <div :class="'tabs-3__pane active'">
                                <div class="row">
                                    <div class="col-md-12" :class="{'answersDirty--class':question.dirtyData && (question.dirtyData.includes('answers') || question.dirtyData.includes('photo'))}">
                                        <section v-if="question.id" class="section">
                                            <div v-if="question.type.slug==='fill_in'">
                                                <table class="table-doc">
                                                    <tbody>
                                                        <tr>
                                                            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('True answer in russian') }}:</th>
                                                            <td class="table-doc__cell">
                                                                <MathJaxComponent :formula="question.trueAnswerRu" />
                                                            </td>
                                                        </tr>
                                                        <tr class="border-bottom">
                                                            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('True answer in kyrgyz language') }}:</th>
                                                            <td class="table-doc__cell">
                                                                <MathJaxComponent :formula="question.trueAnswerKy" />
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('Answer description in russian') }}:</th>
                                                            <td class="table-doc__cell">{{ question.descriptionRu }}</td>
                                                        </tr>
                                                        <tr>
                                                            <th class="table-doc__cell  table-doc__cell--head">{{ getTranslation('Answer description in kyrgyz language') }}:</th>
                                                            <td class="table-doc__cell">{{ question.descriptionKy }}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <div v-if="question.answers.length > 0" class="question--fill-in-answers">
                                                    <table class="table-3 table-borderless">
                                                        <thead class="table-3__head">
                                                            <tr class="table-3__row">
                                                                <th class="table-3__cell  table-3__hcell" style="width: 45%;">{{ getTranslation('Answers in russian') }}</th>
                                                                <th class="table-3__cell  table-3__hcell" style="width: 45%;">{{ getTranslation('Answers in kyrgyz language') }}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody class="table-3__body">
                                                            <tr v-for="item in question.answers" class="table-3__row">
                                                                <td class="table-3__cell" v-html="item.answerRu"></td>
                                                                <td class="table-3__cell" v-html="item.answerKy"></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <table v-if="question.type.slug!=='conformity'" class="table-3 table-borderless">
                                                <thead v-if="question.type.slug!=='fill_in'" class="table-3__head">
                                                    <tr class="table-3__row">
                                                        <th class="table-3__cell  table-3__hcell" style="width: 45%;">{{ getTranslation('answerRu') }}</th>
                                                        <th class="table-3__cell  table-3__hcell" style="width: 45%;">{{ getTranslation('answerKy') }}</th>
                                                        <th class="table-3__cell  table-3__hcell" style="width: 10%;">{{ getTranslation('correctAnswer') }}</th>
                                                    </tr>
                                                </thead>

                                                <tbody v-if="question.type.slug==='multiple' || question.type.slug==='single'" class="table-3__body">
                                                    <tr v-for="item in question.answers" class="table-3__row">
                                                        <td class="table-3__cell" v-html="item.answerRu"></td>
                                                        <td class="table-3__cell" v-html="item.answerKy"></td>
                                                        <td class="table-3__cell">
                                                            <span v-if="item.trueValue">{{ getTranslation('yes') }}</span>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                                <tbody v-if="question.type.slug==='sequence_correct'" class="table-3__body">
                                                    <tr v-for="item in question.answers" class="table-3__row">
                                                        <td class="table-3__cell" v-html="item.answerKy"></td>
                                                        <td class="table-3__cell" v-html="item.answerRu"></td>
                                                        <td class="table-3__cell">
                                                            {{ item.trueValue + 1 }}
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <table v-else-if="question.type.slug==='conformity'" class="table-3 table-borderless">
                                                <thead class="table-3__head">
                                                    <tr class="table-3__row">
                                                        <th class="table-3__cell  table-3__hcell" style="width: 45%;">{{ getTranslation('answers') }}</th>
                                                        <th class="table-3__cell  table-3__hcell" style="width: 45%;">{{ getTranslation('conformityAnswers') }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody v-for="item in question.answers">
                                                    <tr class="table-3__row">
                                                        <td class="table-3__cell">{{item.answerKy}}</td>
                                                        <td class="table-3__cell">{{getConformAnswer(item.trueValue,question.conformity).answerKy}}</td>
                                                    </tr>
                                                    <tr class="table-3__row">
                                                        <td class="table-3__cell">{{item.answerRu}}</td>
                                                        <td class="table-3__cell">{{ getConformAnswer(item.trueValue,question.conformity).answerRu }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                            <div v-if="question.photoUrl" class="mt-4 col-sm-12" :class="{'answersDirty--class':question.dirtyData && question.dirtyData.includes('photo')}">
                                                <div class="section__header-left mb-2">
                                                    <h4 class="section__title">
                                                        {{ getTranslation('questionFigure') }}
                                                    </h4>
                                                </div>
                                                <img :src="question.photoUrl" class="question__photo" alt="Фигура вопроса">
                                            </div>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MathJaxComponent from "@/components/MathJaxComponent";

    export default {
        name: "HistoryView",
        components: { MathJaxComponent },
        data() {
            return {
                question: { id: null },
            }
        },
        updated() {
            if ( this.question.id ) {

                this.setHeadings(
                    {
                        title: this.getTranslation( 'questionHistory' ),
                        breadcrumbs: [
                            {
                                label: this.getTranslation( 'questionHistory' ),
                                route: { name: 'api.question.get', params: { id: this.question.questionId } }
                            },
                            {
                                label: this.getTranslation( 'question' ) + ': ' + this.question.id
                            }
                        ],
                        toBack: {
                            label: this.getTranslation( 'gotoBack' ),
                            route: { name: 'api.question.get', params: { id: this.question.questionId } }
                        }
                    }
                );
            }
        },
        created() {
            this.fetchQuestion( this.$route.params.id );
        },
        methods: {
            fetchQuestion( questionId ) {
                return this.axios.get( this.$config.urls.question.fetchQuestionHistory.url.replace( ':id', questionId ) )
                           .then( response => {
                               this.question = response.data.data;
                           } ).catch(()=>{});
            },
            getConformAnswer( trueValue, conformityAnswers ) {
                for ( let item of conformityAnswers )
                    if ( item.id === trueValue )
                        return item;

                return null;

            }
        }
    }
</script>

<style scoped>
    .dirtyData--class {
        background-color: #93B1E5 !important;
        padding: 3px !important;
    }

    .answersDirty--class {
        background-color: #EC3765 !important;
        padding: 3px !important;
    }

</style>
